
        import '/src/utils/emojiManager.ts';
        import { CookieConsentController } from '/src/services/cookieConsentController.ts';
        
        // Initialize cookie consent when DOM is ready
        document.addEventListener('DOMContentLoaded', () => {
            new CookieConsentController();
        });
    